import { useRef, useCallback } from "react";
import { useConfig } from "../../contexts/config-context.js";
import { extractJapanPostalCode } from "./postal-code.js";
import { useAtlas } from "./use-atlas.js";
function useJapanAutocomplete({
  isAutocompleteEnabled
}) {
  const state = useRef({ hasAddress: false });
  const { instance, language, atlasBaseUrl } = useConfig();
  const atlas = useAtlas({
    enabled: isAutocompleteEnabled,
    getInstance: () => instance ?? "",
    language,
    atlasBaseUrl
  });
  const searchByPostalCode = useCallback(
    async (text) => {
      const postalCode = extractJapanPostalCode(text);
      if (!postalCode) {
        return;
      }
      if (state.current.postalCode === postalCode && state.current.hasAddress) {
        return state.current.address;
      }
      state.current = { postalCode, address: void 0, hasAddress: false };
      try {
        const address = await atlas?.searchByPostalCode({
          countryCode: "JP",
          postalCode
        });
        state.current.hasAddress = true;
        state.current.address = void 0;
        if (address?.formattedAddress) {
          state.current.address = address;
          return address;
        }
        return;
      } catch (e) {
        console.error(e);
      }
      return;
    },
    [atlas]
  );
  return { searchByPostalCode };
}
export {
  useJapanAutocomplete
};
//# sourceMappingURL=use-japan-autocomplete.js.map
